import { register } from "async-ops";
import { throwExceptionErrors } from "../../../../utils/fetch";
import { callMdaeApi } from "../../../../call-web-api";

export const GET_CASES_SUMMARY = "GET_CASES_SUMMARY";

export const service = async () => {
  const options: object = {
    type: "GET",
    url: `/api/v1/cases/summary`,
  };

  const response = await callMdaeApi(options);
  throwExceptionErrors(response);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASES_SUMMARY, service, mock);
